import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    topic: translate({ id: 'supportTicket.validations.topic' }),
    message: translate({ id: 'supportTicket.validations.message' }),
  }))

  return api
}

export type ValidationTexts = ReturnType<typeof useTexts>
